export default {"container":"MXX-X","content":"k22Tt","navItems":"IjN-s"};